import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OfbizList, RemoteFormData } from '@urbannex/ofbiz-forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LookUpDialogService } from '../look-up-dialog.service';

@Component({
  selector: 'ubs-lookup-dialog-list-container',
  templateUrl: './lookup-dialog-list-container.component.html',
  styleUrls: ['./lookup-dialog-list-container.component.scss']
})
export class LookupDialogListContainerComponent implements OnInit,OnDestroy {
  @Input() listForm:OfbizList;
  @Input() title:string;
  isLookup:boolean = true;

  listOptions:any = {};
  remoteFormData:RemoteFormData;
  columnFields:any = {};
  fieldOptions:any = {};

  findParametersSubscription:Subscription;
  private destroy$ = new Subject<void>();
  
  constructor(private lookupDialogService:LookUpDialogService,
    ) { }

  ngOnInit(): void {
    this.findParametersSubscription = this.lookupDialogService.getFindParameters()
      .pipe(takeUntil(this.destroy$))
      .subscribe(parameters => {
        if(parameters){
          this.setRemoteFormData(parameters);
          
        }
      });
    
    this.listOptions.formName = this.listForm.listFormName;
    this.listOptions.entityName = this.listForm.entityName;
    this.listOptions.formLocation = this.listForm.listFormLocation;
    this.listOptions.viewIndex = this.listForm.viewIndex;
    this.listOptions.endPoint = this.listForm.endPoint;
    if(this.listForm.columnFields){
      this.columnFields = this.listForm.columnFields;
    }
    if(this.listForm.labelColumn){
      this.listOptions.labelColumn = this.listForm.labelColumn;
    }
    this.fieldOptions = this.listForm.fieldFormFields;
  }

  onRowSelected(e){
    console.log({TrackLookupSelectedValue:e})
    this.lookupDialogService.setSelectedRow(e);
  }
  /**
   * 
   * @param parameters 
   */
  setRemoteFormData(parameters:any):void{
    Object.keys(parameters).forEach((k) => parameters[k] == null || parameters[k] == "" && delete parameters[k]);
    this.remoteFormData = {
      formData:{
        formName:this.listForm.listFormName,
        formLocation:this.listForm.listFormLocation,
        viewIndex:this.listForm.viewIndex,
      },
      parameters:parameters,
      endPoint:this.listForm.endPoint
    };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    
  }

}
